import sbVerbiage from '@simplybenefits/sb-verbiage';
export default {
  ...sbVerbiage.translations.tokens
};